
import CompareDrawer from '../components/compare/CompareDrawer'
import ComparedProductsBar from '../graphql/queries/ComparedProductsBar'

import { get, call } from 'vuex-pathify'

export default {
  inheritAttrs: false,
  components: {
    CompareDrawer
  },
  props: {
    expand: {
      type: [Boolean, Object],
      default: false
    },
    layout: {
      type: String,
      default: 'table'
    }
  },
  vessel: {
    bar: {
      $attrs: 'all',
      pinBottom: true,
      backgroundColor: 'white',
      color: 'black',
      position: 'fixed',
      zIndex: 50,
      width: 'full',
      paddingY: 'xs',
      paddingX: 'sm',
      fontSize: 'sm'
    },
    clear: {
      textDecoration: 'underline',
      cursor: 'pointer'
    }
  },
  apollo: {
    $client: 'eshop',
    items: {
      query: ComparedProductsBar,
      variables() {
        return {
          where: { id_in: this.visibleIds },
          first: this.perPage
        }
      },
      skip() {
        return !this.visible && !this.$screen.md
      },
      update(data) {
        return data.products.nodes
      }
    }
  },
  data() {
    return {
      items: null
    }
  },
  computed: {
    variantIds: get('productCompare/items'),
    total: get('productCompare/total'),
    visible() {
      return this.total > 0
    },
    perPage() {
      return this.$screen.match({ md: 2, lg: 3 })
    },
    visibleIds() {
      return this.variantIds.slice(0, this.perPage)
    },
    products() {
      return this.visibleIds
        .map(id => this.items.find(item => item.id == id))
        .filter(item => !!item)
    }
  },
  methods: {
    clear: call('productCompare/clear'),
    onClick() {
      this.$drawer.open('product-compare')
    }
  }
}
